import React from "react"
import { Link } from "gatsby"
import Img from "gatsby-image"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Container from "../components/container"
import moment from "moment"
import styled from "@emotion/styled"

const isBrowser = typeof window !== "undefined"
const firebase = isBrowser ? require("firebase/app") : "div"

const Styles = styled.div`
padding: 84px 0px;
  min-height: 100vh;


  .my-graduates {
    display: grid;
    grid-gap: 64px;
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));

    .my-graduate {
      overflow-wrap: break-word;

      .gatsby-image-wrapper {
        height: 135px;
      }
      
    }
  }

  .my-image {
    border-bottom: 1px solid #ccc;
    .gatsby-image-wrapper {
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
    }
    
  }

  .card {
    border-radius: 4px;
    border: 1px solid #ccc;

    .card-content {
      padding: 10px;
    }
  }
`

class Page extends React.Component {
  constructor() {
    super()
    this.state = {}
    this.state.graduates = []
  }

  componentDidMount() {
    firebase
      .firestore()
      .collection("profiles")
      .where("graduated", "==", true)
      .onSnapshot(this.setGraduates.bind(this))
  }

  setGraduates(snap) {
    this.setState({ graduates: snap.docs })
  }

  transformImage(url) {
    let small = url.split("upload/").join("upload/w_600/") + " 600w,\n"
    let medium = url.split("upload/").join("upload/w_900/") + " 900w,\n"
    let large = url.split("upload/").join("upload/w_1200/") + " 1200w,\n"
    let max = url.split("upload/").join("upload/w_1500/") + " 1500w,\n"

    let sizes = "(max-width: " + 2000 + "px) 100vw " + 2000 + "px"

    let fluid = {}

    fluid.aspectRatio = 2000 / 2000
    fluid.src = url
    fluid.sizes = sizes
    fluid.srcSet = small + medium + large + max

    return fluid
  }

  graduate(el) {
    let data = el.data()
    return (
      <div className="my-graduate card" key={el.id}>
        <div className="my-image card-image">
          <a
            href={data.graduation.url}
            target="_blank"
            rel="noreopener noreferrer"
          >
            <Img
              fluid={this.transformImage(data.image || "")}
              alt={data.name || "Profile Picture"}
            />
          </a>
        </div>

        <div className="card-content">
        <div>{data.name}</div>

        <div>
          <small>
          <a
            href={data.graduation.url}
            target="_blank"
            rel="noreopener noreferrer"
          >
            {data.graduation.url}
          </a>
          </small>
        </div>

        <div>
          <small style={{ color: "#777" }}>
            {moment(data.graduated.time).format("MMMM Do, YYYY")}
          </small>
        </div>
        </div>
      </div>
    )
  }

  render() {
    return (
      <Layout path="graduates">
        <SEO title="Graduates" />
        <Styles>
          <Container>
            <div className="title">Graduates</div>

            <div className="my-graduates">
              {this.state.graduates.map(this.graduate.bind(this))}
            </div>
          </Container>
        </Styles>
      </Layout>
    )
  }
}

export default Page
